/**
 * Timing constants (ms)
 */
export const DELAY = {
  ACCESS_OPACITY: 200,
  DESCRIPTION_CONTENT: 200,
  DESCRIPTION_HEADER: 200,
  DETAIL_CONTENT: 200,
  MENU_ITEM_ICON: 0,
  PILOT_FOOTER_CONTENT: 200,
  PLAYER_CONTAINER: 300,
  RAILS_CONTAINER: 300,
  SLIDER_LIST_CONTAINER: 300,
  SLIDER_PRESSABLE_CONTAINER: 500,
} as const;

export const DURATION = {
  DESCRIPTION_HEADER: 200,
  DIAL_INPUT: 200,
  MENU_CONTAINER: 200,
  MENU_LOGIN: 200,
  MENU_ITEM_OPACITY: 100,
  MENU_ITEM_ICON: 100,
  MENU_ITEM_TEXT: 100,
  MENU_SEARCH_FILL: 200,
  MENU_SEARCH_OPACITY: 200,
  MENU_SEARCH_TRANSLATION: 200,
  PLAYER_CONTAINER: 300,
  RAILS_CONTAINER: 300,
  SLIDER_LIST_CONTAINER: 300,
  TOP_BAR_CONTAINER: 200,
  SPLASH: 200,
} as const;

/**
 * CSS transitions
 */
export const TRANSITION = {
  MENU_CONTAINER: (collapse: boolean) =>
    collapse
      ? `width ${DURATION.MENU_CONTAINER}ms ease-out, 
            background ${DURATION.MENU_CONTAINER}ms ease-out,
            border ${DURATION.MENU_CONTAINER}ms ease-out, 
            padding-left ${DURATION.MENU_CONTAINER}ms ease-out, 
            margin-right ${DURATION.MENU_CONTAINER}ms ease-out`
      : `width ${DURATION.MENU_CONTAINER}ms ease-out, 
            background ${DURATION.MENU_CONTAINER}ms ease-out,
            border ${DURATION.MENU_CONTAINER}ms ease-out,
            padding-left ${DURATION.MENU_CONTAINER}ms ease-out, 
            margin-right ${DURATION.MENU_CONTAINER}ms ease-out`,
  MENU_ITEM_TEXT: `max-width ${DURATION.MENU_ITEM_TEXT}ms ease-out, 
    padding-left ${DURATION.MENU_ITEM_TEXT}ms ease-out, 
    padding-right ${DURATION.MENU_ITEM_TEXT}ms ease-out`,
  MENU_ITEM_ICON: (collapse: boolean) =>
    collapse
      ? `margin-right ${DURATION.MENU_ITEM_ICON}ms ease-out ${DELAY.MENU_ITEM_ICON}ms`
      : '',
  MENU_SEARCH_FILL: `fill ${DURATION.MENU_SEARCH_FILL}ms ease-out`,
  MENU_SEARCH_TRANSLATION: `left ${DURATION.MENU_SEARCH_TRANSLATION}ms ease-out`,
} as const;
